var android = undefined;
export default class JsInterfaceService {
  static enterFullScreen() {
    // console.log("enterFullScreen");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        android = LoanWeb;
        if (typeof android !== "undefined") android.enterFullScreen("");
      } else {
        window.webkit.messageHandlers.enterFullScreen.postMessage("");
      }
    } catch (error) {
      console.error("error enterFullScreen");
      throw error;
    }
  }
  static exitEntryPoint() {
    // console.log("exitEntryPoint");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["closeWebview"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "closeWebview",
        });
      }
    } catch (error) {
      console.error("error exitEntryPoint");
      throw error;
    }
  }
  static requestCamera() {
    // console.log("requestCamera");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    // console.log("isAndroid", isAndroid);
    try {
      if (isAndroid) {
        window.JSBridge["requestCamera"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "requestCamera",
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error requestCamera");
      throw error;
    }
  }
  static openLfmStatusPage() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionStatusPage"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionStatusPage",
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error openLfmStatusPage");
      throw error;
    }
  }

  static openLFMProductionShelf() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionShelf"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionShelf",
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error openLFMProductionShelf");
      throw error;
    }
  }

  static requestGallery() {
    // console.log("requestGallery");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["requestGallery"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "requestGallery",
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error requestGallery");
      throw error;
    }
  }

  static openLFMProductionShelfWithLoanAppID(loanAppID) {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionShelf"]?.(loanAppID);
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionShelf",
          loanAppId: loanAppID
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error openLFMProductionShelf");
      throw error;
    }
  }

  static gaTagging(
    event,
    firebaseParam = [],
    trackAppsflyer = false,
    trackGA = true,
    appsflyerParam = undefined
  ) {
    // remove pt_information for tracking Appsflyer
    if (trackAppsflyer && firebaseParam) {
      const indexOfPTInformation = firebaseParam.findIndex(
        (object) => object.key === this.GA_CUSTOM_DIMENSION.PT_INFORMATION
      );
      if (indexOfPTInformation !== -1) {
        firebaseParam.splice(indexOfPTInformation, 1);
      }
    }

    let data;
    if (appsflyerParam !== undefined) {
      data = { event, trackAppsflyer, trackGA, appsflyerParam };
    } else {
      data = firebaseParam.length > 0
        ? { event, firebaseParam, trackAppsflyer, trackGA }
        : { event, trackAppsflyer, trackGA };
    }

    console.log('========== START GA TAGGING ==========');
    const body = JSON.stringify(data);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;

    console.log('Platform =>', isAndroid ? 'Android' : 'iOS');
    console.log('Tagging At', new Date().toString());
    console.log('Payload =>', data);

    try {
      if (isAndroid) {
        window.JSBridge.analyticTracking?.(body);
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: 'analyticTracking',
          data: body,
        });
      }
      console.log('Status => Success');
    } catch (error) {
      console.log('Status => Fail');
      console.log(`Error => ${error}`);
    } finally {
      console.log('=========== END GA TAGGING ===========');
    }
  }

  static openLFMProductionHighlight() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionHighlight"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionHighlight"
        });
      }
    } catch (error) {
      console.error(error);
      // console.log("error openLFMProductionShelf");
      throw error;
    }
  }

}
